import axios from "axios";

export default function setUserAuthenticationToken(token){
    if(token){
        axios.defaults.headers.common['id'] = token;
    }else{
        delete axios.defaults.headers.common['id'];
    }
}